import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import CalonMhsService from "../../services/CalonMhsService";
import {message} from "antd";
import {
    AUTH_MASUKAN,
    AUTH_NAMA_PENGGUNA,
    AUTH_NOMOR_PENDAFTARAN,
    AUTH_TOKEN,
    FOTO_CMHS
} from "../../constants/AuthConstant";

export const initialState = {
    loadingPendaftarByUser: false,
    dataPendaftarByUser: [],
    showMessage:false,
    message:'',
}


export const getDataPendaftarByUser = createAsyncThunk('transaksi/pendaftarbyuser',async (data, { rejectWithValue }) => {
    try {
        const response = await CalonMhsService.getDataByUser(localStorage.getItem(AUTH_TOKEN))
        //console.log(JSON.stringify(response))
        if(response.success===true){
            localStorage.setItem(FOTO_CMHS, response.data[0].foto);
        }
        return response
    } catch (err) {
        message.error(err.response?.data?.message || 'Error',3,function (err) {
            localStorage.removeItem(AUTH_TOKEN);
            localStorage.removeItem(AUTH_NOMOR_PENDAFTARAN);
            localStorage.removeItem(AUTH_NAMA_PENGGUNA);
            localStorage.removeItem(AUTH_MASUKAN);
            localStorage.removeItem(FOTO_CMHS);

            window.location.href = "auth/login";
        })
    }
})


export const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {
            showLoadingPendaftarByUser: (state) => {
                state.loadingPendaftarByUser = true
            },
            showDataPendaftar:(state,action) => {
                state.loadingPendaftarByUser = false
                state.dataPendaftarByUser = action.payload.data
            },
        },
    extraReducers: (builder) => {
        builder
            .addCase(getDataPendaftarByUser.fulfilled, (state, action) => {
                state.dataPendaftarByUser = action.payload.data
                state.loadingPendaftarByUser = false
            })
            .addCase(getDataPendaftarByUser.pending, (state) => {
                state.loadingPendaftarByUser = true
            })
            .addCase(getDataPendaftarByUser.rejected, (state, action) => {
                state.dataPendaftarByUser = action.payload.data
                state.loadingPendaftarByUser = false
            })
    },
})

export const {
    showLoadingPendaftarByUser,
    showDataPendaftar
} = dashboardSlice.actions

export default dashboardSlice.reducer
